import { Action } from "./Action.js";
import { getElementByIdInContext } from "../lib/utils.js";
import i18next from "i18next";

/**
 * @class OpenWindow
 * @extends Action
 * @classdesc Действие Открыть окно
 * */
export class OpenWindow extends Action {
    execute(context) {
        if (!this.WindowID) {
            $ns.add({
                type: "warning",
                time: new Date().toLocaleString(),
                title: i18next.t("title_window_not_found"),
                text: i18next.t("window_not_found"),
            });
            return;
        }

        let calcWinId = this.calcParam(this.WindowID, context);
        if (calcWinId == null)
            return;
        let winId = this.recalcWindowId(calcWinId);
        if ($pm.hasPermissions) {
            const targetContext = context.currentTarget || context.target;
            $pm.resolveOpenWindow(
                targetContext,
                winId,
                this.ObjectId || $WinDefs.winDef[winId]?.objectid,
                this.continueExecution.bind(this, context, winId)
            );
        } else {
            this.continueExecution(context, winId);
        }
    }
    continueExecution(context, winId) {
        const winModel = this.createWinModel(context, winId);
        if (this.OpenNew == true) {
            window.open(this.createUrl(winModel, winId), "_blank", this.createFeatures(winModel));
            return;
        }

        const frame = this.FrameID
            ? getElementByIdInContext(this.context, this.FrameID)
            : document.querySelector("ms-frame");
        const win = frame.openWindow(winModel);
        this.msWin = win;

        if (this.parameters) {
            for (const key in this.parameters) {
                win.SetParameter(
                    key.toLowerCase(),
                    this.calcParam(this.parameters[key], context)
                );
            }

            if (this.prop_link) {
                const keys = Object.keys(this.prop_link);
                for (let index = 0; index < keys.length; index++) {
                    let key = keys[index].toLowerCase();
                    if (key in win) {
                        let oldLink = this.msWin.propLink[key];
                        if (oldLink) {
                            this.msWin.AddLinkCallback(
                                key,
                                (
                                    element,
                                    linkUp,
                                    value,
                                    attrName,
                                    itemIndex
                                ) => {
                                    oldLink(
                                        element,
                                        linkUp,
                                        value,
                                        attrName,
                                        itemIndex
                                    );
                                    this.LinkUp(
                                        element,
                                        linkUp,
                                        value,
                                        attrName,
                                        itemIndex
                                    );
                                }
                            );
                        } else
                            this.msWin.AddLinkCallback(
                                key,
                                this.LinkUp.bind(this)
                            );
                    }
                }
            }
        }
    }

    createWinModel(context, winId) {      
        const windDef = $WinDefs.winDef[winId];

        const { objectid, taskid, outerpath } =
            windDef.objectid === "0"
                ? $sw.ItemSubscription.GetInstanceFields(this)
                : windDef;

        return {
            ...windDef,
            ...(objectid ? { objectid } : {}),
            ...(taskid ? { taskid } : {}),
            ...(outerpath ? { outerpath } : {}),
        };
    }

    createUrl(windModel, winId) {
        const props = ["objectid", "taskid", "outerpath"];
        let url = props.reduce((acc, val) => {
            const prop = windModel[val];
            return prop && prop !== "0"
                ? `${acc}&${val}=${encodeURIComponent(prop)}`
                : acc;
        }, `?${winId}`);
        if (this.parameters) {
            let pars = {};
            for (const key in this.parameters) {
                pars[key.toLowerCase()] = this.parameters[key];
            }
            url += `&parameters=${encodeURIComponent(JSON.stringify(pars))}`;
        }
        return url;
    }

    createFeatures(winModel) {
        const params = this.parameters || {};
        const lowerCaseKeysParams = Object.keys(params).reduce((acc, key) => {
            acc[key.toLowerCase()] = params[key];
            return acc;
        }, {});
        const winProps = ["width", "height", "x", "y"];
        return winProps.reduce((acc, val) => {
            const prop = lowerCaseKeysParams[val] ?? winModel[val] ?? 0;
            return `${acc},${val}=${prop}`;
        }, "");
    }

    get WindowID() {
        return typeof this._WindowID === "undefined" ? "" : this._WindowID;
    }
    set WindowID(value) {
        this._WindowID = value;        
    }

    get FrameID() {
        return typeof this._FrameID === "undefined" ? "" : this._FrameID;
    }
    set FrameID(value) {
        if (value.toString().includes(".")) {
            this._FrameID = $pr.getWindowIdByPath(value);
        } else {
            this._FrameID = value;
        }
    }

    UpdateParameters(PropertyPath, value) {
        if (this.msWin && this.parameters_bychange?.[PropertyPath])
            this.msWin.SetParameter(PropertyPath.toLowerCase(), value);
        this.parameters[PropertyPath] = value;
    }

    recalcWindowId(winpath) {
        if (winpath.toString().includes(".")) {
            let winid = $pr.getWindowIdByPath(winpath);
            if (
                typeof $WinDefs.winDef[winid] !== "undefined" &&
                $WinDefs.winDef[winid].objectid === "0"
            ) {
                const { objectid, outerpath } = $pr.getObjectIdByPath(winpath);
                this.ObjectId = objectid;
                this.FullOuterPath = outerpath;
            }
            return winid;
        }
        return winpath;
    }
}
